import { theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const CharacteristicName = styled.td<{ isTooltip?: boolean }>`
  font-weight: bold;
  text-decoration: none;
  color: ${theme.color.text.primary};
  border-bottom: ${(props) => (props.isTooltip ? '1px dashed' : 'none')};
  border-bottom-color: ${theme.color.border.selected};
  display: inline-block;
  width: fit-content;

  div:first-child {
    cursor: ${(props) => (props.isTooltip ? 'help' : 'default')};
  }

  border: none;
  display: table-cell;
  ${theme.typography.labelRegular400};
  padding: 0;
`;

export const CharacteristicValue = styled.td`
  padding: 0;
  ${theme.typography.labelRegular400}
`;

export const CharacteristicRow = styled.tr<{ fullWidth?: boolean }>``;

export const CharacteristicsTableWrapper = styled.div<{ noMargin?: boolean }>`
  margin-bottom: ${(props) => (props.noMargin ? '0' : '3rem')};
  width: 100%;
`;

export const fadeCropClassName = css`
  max-height: 264px;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6rem;
    pointer-events: none;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      ${theme.color.background.primary} 100%
    );
  }
`;

export const ShowParametersButton = styled.button`
  all: unset;
  cursor: pointer;
  text-decoration: underline;
  padding: 12px 0;
  margin-top: 12px;
  ${theme.typography.labelRegular}
`;

export const drawerHeaderClassName = css`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
`;
